const { Event } = require( '@leverege/api-redux' )

const Actions = Event( { reduxKey : 'events' } )

Object.assign( module.exports, Actions )
